import { apiFetch } from "./fetchApi";

export const fetchGetUsers = async (BeURL, showAlert, setUsers, userId) => {
    try {
        // 2️⃣ Send companyId as param for get manager Ids creation

        const res = await apiFetch(`${BeURL}/user-data/${userId}`, {
            method: "GET",
        });

        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
            return;
        }

        setUsers(data.userData)


    } catch (err) {
        console.error("Error in Fetch User:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}

export const fetchAllUsers = async (BeURL, showAlert, setUsers, companyId) => {
    try {
        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/users-data/${companyId}`, {
            method: "GET",
        });

        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
            return;
        }

        setUsers(data.users)


    } catch (err) {
        console.error("Error in Fetch All Users:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}


export const fetchAProfileActionHistory = async (BeURL, showAlert, setProfileActionHistory) => {
    try {
        //Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/fetch-profile-action-history`, {
            method: "GET",
        });
        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
            return;
        }
        setProfileActionHistory(data.data)
    } catch (err) {
        console.error("Error in Fetch All Users:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}

export const updateUsers = async (BeURL, showAlert, formData1, id, navigate) => {
    try {
        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/update-users/${id}`, {
            method: "POST",
            body: formData1
        });

        const data = await res.json();
        if (data.success) {

            showAlert(data.message);
            setTimeout(() => {
                navigate('/list-users')
            }, 1000);


        }
        else {
            showAlert(data.message);
        }

        // setUsers(data.users)
       
    } catch (err) {
        console.error("Error in Fetch All Users:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}

// Users Delete apis

export const deleteUserConfrim = async (BeURL, showDeleteConfirm, showAlert, id) => {
    try {
        const res = await apiFetch(`${BeURL}/delete-user/${id}/confirm`, {
            method: "GET",
        })

        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
            return;
        }

        const confirmed = await showDeleteConfirm(data.message);
        return confirmed;


    } catch (err) {
        console.error("Error in Delete User confrimation:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}

export const deleteUser = async (BeURL, showAlert, id) => {
    try {
        const res = await apiFetch(`${BeURL}/user-delete/${id}`, {
            method: "delete",
        });

        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
            return;
        }

        showAlert(data.message)
        window.location.reload()


    } catch (err) {
        console.error("Error in Delete client :", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}


